<template>
    <div>
        <h1 style="font-size: 24px; color: black;">信息流广告配置 </h1>
        <el-card class="form-container" shadow="never">
            <el-button class="sub-sub" type="primary" @click="showDetails('新增策略')">新增策略</el-button>
        </el-card>
        <h1>
            <el-table :data="feedStrategyList"
                    border
                    :fit="true">
                <el-table-column label="策略ID" prop="id" align="center"></el-table-column>
                <el-table-column label="创建时间"  align="center">
                    <template slot-scope="scope">
                        {{ formatDate(scope.row.createDt,"YYYY-MM-DD HH:mm:ss")}}
                    </template>
                </el-table-column>
                <el-table-column label="策略名称" prop="name" align="center"></el-table-column>
                <el-table-column label="选定应用" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.appNameValue.join(" , ")}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑策略',scope.row)">编辑</el-button>
                        <el-button plain size="mini" type="danger" @click="deleteFeed(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1200px">
            <el-form :model="feedStrategyForm">
                <el-form-item label="策略名称 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="feedStrategyForm.name" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="app应用 :" :label-width="labelWidth">
                    <el-select  v-model="feedStrategyForm.appName" placeholder="请选择" multiple>
                        <el-option
                                v-for="item in appList"
                                :key="item.appId"
                                :label="item.appName"
                                :value="item.packageName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="规则配置 :" :label-width="labelWidth">
                    <el-button circle icon="el-icon-plus" size="mini" type="primary" @click="addRule"></el-button>
                    <el-table :data="feedStrategyForm.feedRules"
                             border
                            :fit="true">
                    <el-table-column label="规则编号" type="index" width="100px" align="center"></el-table-column>
                    <el-table-column label="规则内容"   align="center">
                        <template slot-scope="scope">
                            <el-row :gutter="20">
                            <el-col :span="3">游戏内容</el-col>
                            <el-col :span="4"><el-input-number  size="mini" :min="0" v-model="scope.row.gameQuantity"></el-input-number></el-col>
                            <el-col :span="1">插</el-col>
                            <el-col :span="4"><el-input-number  size="mini" :min="0" v-model="scope.row.feedQuantity"></el-input-number></el-col>
                            <el-col :span="2">信息流</el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="80px">
                        <template slot-scope="scope">
                             <el-button  circle icon="el-icon-minus" size="mini" type="danger"
                              @click.native.prevent="reduceRule(scope.$index,feedStrategyForm.feedRules)"></el-button>
                        </template>
                    </el-table-column>
                    </el-table>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm" >提 交</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        appAll,
        feedSave,
        feedUpdate,
        feedStrategyList,
        feedDelete
    } from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "FeedConfig",
        inject: ['reload'],
        data(){
            return{
                feedStrategyForm: {},
                feedRulesForm:{},
                dialogTitle:'',
                dialogVisible:false,
                labelWidth: '110px',
                appList:[],
                feedStrategyList:[]
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            showDetails(title, row) {
                this.feedStrategyForm = {
                    "id": 0,
                    "name": "",
                    "appName": [],
                    "feedRules": [],
                };
                this.dialogTitle = title;
                this.dialogVisible = true;
                if (row) {
                    this.feedStrategyForm = {
                        "id": row.id,
                        "name": row.name,
                        "appName": row.appNameKey,
                        "feedRules": row.feedRules,
                    };
                }
            },
            addRule() {
                this.feedStrategyForm.feedRules.push({
                    id: 0,
                    strategyId: 1,
                    gameQuantity:0,
                    feedQuantity:0
                })
            },
            reduceRule(index, rows) {
                rows.splice(index, 1);
            },
            deleteFeed(id){
                this.$confirm('此操作将永久删除该版本, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    feedDelete(id).then(resp => {
                        if (resp.data.status === 0) {
                            this.reload();
                        }
                    })
                }).catch(() => {
                });
            },
            confirmForm(){
                let _message = '';
                if(this.feedStrategyForm.name===''){
                    _message = '请输入策略名称'
                }else if (this.feedStrategyForm.appName.length<1){
                    _message = '请选择app应用'
                }else if (this.feedStrategyForm.feedRules.length<1){
                    _message = '请添加规则'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                if (this.dialogTitle==='新增策略'){
                    feedSave(this.feedStrategyForm).then(resp=>{
                        if(resp.data.status===0){
                            this.reload();
                            this.dialogVisible=false;
                        }
                  });
                }else {
                    feedUpdate(this.feedStrategyForm).then(resp=>{
                        if(resp.data.status===0){
                            this.reload();
                            this.dialogVisible=false;
                        }
                    })
                }
            }
        },
        created() {
            appAll().then(resp =>{
                this.appList = resp.data.info;
            });
            feedStrategyList().then(resp=>{
                this.feedStrategyList = resp.data.info
            })
        }
    }
</script>

<style scoped>

</style>